import React from 'react';
import RequestResetPassword from '../../components/ResetPassword/RequestResetPassword';
import { requestPasswordReset } from '../Authentication/LoginActions';
import { connect } from 'react-redux';

import Waitable from '../../components/Waitable';

class RequestResetPasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

  }
  onSubmit(data) {
    this.props.dispatch(requestPasswordReset(data));

  }
  render() {
    let email = null;
    if (this.props.form && this.props.form.values && this.props.form.values.email) {
      email = this.props.form.values.email;
    }
    return (
      <Waitable showError={false} entities={[this.props.passwordReset]}>
        <div className="col-md-12">
          <RequestResetPassword
            success={this.props.passwordReset.get('data')}
            error={this.props.passwordReset.get('error')}
            email={email}
            onSubmit={this.onSubmit}
          />
        </div>
      </Waitable>
    );
  }
}

const mapStateToProps = (state) => {
  return ({ passwordReset: state.authentication.passwordReset, form: state.form.ResetForm });
};


export default connect(mapStateToProps)(RequestResetPasswordContainer);


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/RequestResetPasswordContainer.js